import React from "react";
import Card from "./Card";
import styles from "./StatusBlock.module.css";

function StatusBlock(props) {
  return (    
    <Card>
      <div className={styles.title + ' ft-12'}>{props.title}</div>
      {props.loading ? 'Loading...' : props.children}
    </Card>
  );
}

export default StatusBlock;